import { useEffect } from 'react';

export const WebSiteSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Klexu",
    "alternateName": "Klexu AI Solutions",
    "url": "https://klexu.com/",
    "description": "AI-powered digital transformation solutions including AI strategy, data engineering, predictive analytics, and process automation for businesses.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://klexu.com/blog?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Klexu",
      "url": "https://klexu.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://klexu.com/icon.png"
      },
      "sameAs": [
        "https://www.linkedin.com/company/klexu",
        "https://twitter.com/klexu"
      ]
    }
  };

  useEffect(() => {
    const scriptId = 'website-schema';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    
    script.textContent = JSON.stringify(schema);
    
    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null;
};

export default WebSiteSchema;
